import { Navigate, Outlet } from 'react-router-dom'

const RoleProtectedRoute = ({ allowedRoles = [] }) => {
  const role = (sessionStorage.getItem('role') || '').toUpperCase()
  const isAllowed = allowedRoles.includes(role)

  return isAllowed ? <Outlet /> : <Navigate to="/index" replace />
}

export default RoleProtectedRoute
